import { render, staticRenderFns } from "./PawnLicence.vue?vue&type=template&id=48b8622a&scoped=true&"
import script from "./PawnLicence.vue?vue&type=script&lang=js&"
export * from "./PawnLicence.vue?vue&type=script&lang=js&"
import style0 from "./PawnLicence.vue?vue&type=style&index=0&id=48b8622a&prod&lang=less&scoped=true&"
import style1 from "./PawnLicence.vue?vue&type=style&index=1&id=48b8622a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b8622a",
  null
  
)

export default component.exports